import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Tracks SPA page views in Google Analytics on every route change.
 * GA script must already be loaded in index.html.
 */
const useGAPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);
};

export default useGAPageView;
